/* eslint-disable react/forbid-prop-types */
import { Container, Hidden, LinearProgress, Toolbar } from '@material-ui/core';
import ProfileHeader from 'app/components/ProfileHeader';
import { Sidebar, TopBar } from 'app/components/ui';
import { LAYOUT_TYPES } from 'app/constants';
import { useRouterGuard } from 'app/guards/useRouterGuard';
import { getContext } from 'app/store/slices/context.slice';
import { loaderSelector } from 'app/store/slices/loader.slice';
import PropTypes from 'prop-types';
import React, { Suspense, useState } from 'react';
import { useSelector } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { navbarItems } from './navbarItems';
import useStyles from './UserLayout.styles';

const OfficeLayout = ({ route }) => {
	const { isLoading } = useSelector(loaderSelector);
	const context = useSelector(getContext);
	const classes = useStyles();
	const [openNavBarMobile, setOpenNavBarMobile] = useState(false);

	useRouterGuard(LAYOUT_TYPES.OFFICE);

	const handleNavBarMobileOpen = () => {
		setOpenNavBarMobile(true);
	};

	const handleNavBarMobileClose = () => {
		setOpenNavBarMobile(false);
	};

	if (!context) {
		return null;
	}

	return (
		<div className={classes.root}>
			<Hidden lgUp>
				<TopBar className={classes.topBar} onOpenNavBarMobile={handleNavBarMobileOpen} />
			</Hidden>
			<div className={classes.container}>
				<Sidebar
					onMobileClose={handleNavBarMobileClose}
					openMobile={openNavBarMobile}
					currentNavbarItems={navbarItems.office}
				/>
				<main className={classes.content}>
					<Toolbar className={classes.toolbar}>
						<ProfileHeader />
					</Toolbar>
					<Suspense fallback={<LinearProgress className={classes.progressBar} />}>
						<Container className={classes.mainContainer}>
							{isLoading && <LinearProgress className={classes.progressBar} />}
							{renderRoutes(route.routes)}
						</Container>
					</Suspense>
				</main>
			</div>
		</div>
	);
};

OfficeLayout.propTypes = {
	route: PropTypes.shape({
		path: PropTypes.string,
		component: PropTypes.func,
		routes: PropTypes.array,
	}).isRequired,
};

export default OfficeLayout;
